var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isFirstBooking)?_c('div',{staticClass:"d-inline-flex align-items-center"},[_c('div',{staticClass:"badge-status text-status status-first-reservation"},[_vm._v("First Reservation")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }